<form [formGroup]="searchBankFormGroup">
    <div class="d-lg-flex d-sm-flex mb-5">
        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 mr-lg-3 mr-sm-3 field-cont">
            <label class="field-label">Bank Name</label>
            <input type="text" matInput class="form-control" formControlName="bankName" placeholder="Please enter bank name" [matAutocomplete]="autoBankName"
                   [(ngModel)]="bankAccount.bank_name" (focusout)="validateBankName()">
            <mat-autocomplete #autoBankName="matAutocomplete" (optionSelected)="onBankNameSelected()">
                <mat-option *ngFor="let bankName of filteredBankNames | async"
                            [value]="bankName">
                    {{ bankName }}
                </mat-option>
            </mat-autocomplete>
            <mat-error  class="small" *ngIf="searchBankFormGroup.controls.bankName.dirty && searchBankFormGroup.controls.bankName.errors">
                {{ getErrorMessage(searchBankFormGroup.controls.bankName) }}
            </mat-error>
        </div>
        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 field-cont">
            <label class="field-label">Bank City</label>
            <input type="text" matInput class="form-control" formControlName="bankCity" (ngModelChange)="getCityName()" placeholder="Please enter bank city"
                   [matAutocomplete]="autoBankCity" [(ngModel)]="bankAccount.branch_city" (focusout)="validateBankCity()">
            <mat-autocomplete #autoBankCity="matAutocomplete" (optionSelected)="onCitySelected()">
                <mat-option *ngFor="let cityName of filteredCities | async" [value]="cityName">
                    {{ cityName }}
                </mat-option>
            </mat-autocomplete>
            <mat-spinner [diameter]="35" class="mat-spinner" matSuffix *ngIf="loadingCities"></mat-spinner>
            <mat-error  class="small" *ngIf="searchBankFormGroup.controls.bankCity.dirty && searchBankFormGroup.controls.bankCity.errors">
                {{ getErrorMessage(searchBankFormGroup.controls.bankCity) }}
            </mat-error>
        </div>
    </div>
    <div class="d-lg-flex d-sm-flex mb-5">
        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 mr-lg-3 mr-sm-3 field-cont">
            <label class="field-label">Bank Branch</label>
            <input type="text" matInput class="form-control" formControlName="bankBranchName" placeholder="Please enter branch name" [matAutocomplete]="autoBankBranch"
                   [(ngModel)]="bankAccount.branch_name" (focusout)="validateBankBranch()">
            <mat-autocomplete #autoBankBranch="matAutocomplete" (optionSelected)="onBankBranchSelected()">
                <mat-option *ngFor="let bankBranch of filteredBankBranches" [value]="bankBranch">
                    {{ bankBranch }}
                </mat-option>
            </mat-autocomplete>
            <mat-spinner [diameter]="35" class="mat-spinner" matSuffix *ngIf="loadingBranches"></mat-spinner>
            <mat-error  class="small" *ngIf="searchBankFormGroup.controls.bankBranchName.dirty && searchBankFormGroup.controls.bankBranchName.errors">
                {{ getErrorMessage(searchBankFormGroup.controls.bankBranchName) }}
            </mat-error>
        </div>
        <div class="col-lg-6 col-sm-6 col-xs-12 p-0 field-cont">
            <label class="field-label">Bank's IFSC</label>
            <input type="text" class="form-control" formControlName="ifscCode" placeholder="Enter IFSC code" [(ngModel)]="bankAccount.ifsc">
            <mat-error  class="small" *ngIf="searchBankFormGroup.controls.ifscCode.dirty && searchBankFormGroup.controls.ifscCode.errors">
                {{ getErrorMessage(searchBankFormGroup.controls.ifscCode) }}
            </mat-error>
        </div>
    </div>
</form>
